import React from "react";
import { CreateButton, List, ListActions, Title, useStore } from "react-admin";
import { Box, Typography, Paper, useMediaQuery } from "@mui/material";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import StreamsWeeklyScheduleTable from "./StreamsWeeklyScheduleTable";
import CustomFilter from "features/CustomFilter";
import useSemesterFilter from "features/filters/useSemesterFilter";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { getPermissions } from "auth/security/securityUtils";
import { mguExporter } from "utils/tenants";

export const STREAMS_FILTERS_KEY = "weeklyScheduleStream.filters";

const ListStreamsWeeklySchedule = () => {
  const userPermissions = getPermissions();
  const [filters, setFilters] = useStore(STREAMS_FILTERS_KEY, null);
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const semester = useSemesterFilter({ filters, withStudyType: true, sessionField: "sessionType" });

  const handleSearch = selectedFilters => {
    const hasChanged =
      !filters ||
      filters.academicYearId !== selectedFilters.academicYearId ||
      filters.studyTypeId !== selectedFilters.studyTypeId ||
      filters.sessionType !== selectedFilters.sessionType;

    if (hasChanged) {
      setFilters(selectedFilters);
    }
  };

  return (
    <>
      {!filters && <Title title={"Занятия в поток"} />}
      <CustomFilter
        title="Избери филтри"
        cardWidth={isMobile ? "100%" : "700px"}
        filters={semester.fields}
        buttonLabel="Покажи"
        buttonDisabled={!semester.isComplete}
        buttonOnClick={() => handleSearch(semester.query)}
      />
      {!filters ? (
        <Paper sx={{ mt: 5 }}>
          <Box
            p={2}
            sx={{ display: "flex", justifyContent: "center", gap: 3 }}
          >
            <Typography
              align="center"
              color="secondary"
            >
              Въведи филтри за занятия в поток.
            </Typography>
            <CreateButton />
          </Box>
        </Paper>
      ) : (
        <List
          title="Занятия в поток"
          actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateWeeklySchedule)} />}
          filter={filters}
          exporter={mguExporter}
        >
          <StreamsWeeklyScheduleTable />
        </List>
      )}
    </>
  );
};

export default ListStreamsWeeklySchedule;
